module.exports = __webpack_public_path__ + "static/media/member-emblem-orange.a34ca3c9.png";